import { client } from "utils";

export const getKeywordScanStatsRequest = (forceRefresh) => (
    client.get(`keyword-scan-stats${forceRefresh ? "?force_refresh=true" : ""}`)
);
